import './NotifyButton.css';
export var overlay = '_77etjd0-2-0-1';
export var toast = '_77etjd1-2-0-1';